import { getBorderRadiusValue } from './borderRadius';

function getPadding(padding, isMobile) {
    return padding
        ? `${isMobile && padding.top >= 20 ? padding.top / 2 : padding.top / 1.6}px ${isMobile && padding.right >= 20 ? padding.right / 2 : padding.right / 1.6}px ${isMobile && padding.bottom >= 20 ? padding.bottom / 2 : padding.bottom / 1.6}px ${isMobile && padding.left >= 20 ? padding.left / 2 : padding.left / 1.6}px`
        : undefined;
}

export function getCheckboxOptionWrapperStyle(style, isMobile = false) {
    const hasOptionBorder = !!style?.optionBorderColor;
    const optionPadding = getPadding(style?.optionPadding, isMobile);
    return hasOptionBorder || style?.optionBorderRadius || optionPadding ? {
        border: hasOptionBorder ? `1px solid ${style.optionBorderColor}` : undefined,
        borderRadius: getBorderRadiusValue(style?.optionBorderRadius),
        padding: optionPadding,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
    } : undefined;
}

export function getCheckboxCheckedCss(className, checkedColor) {
    if (!checkedColor) {
        return '';
    }
    return `
.${className} .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${checkedColor} !important;
    border-color: ${checkedColor} !important;
}
.${className} .ant-checkbox-wrapper:hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner,
.${className} .ant-checkbox:hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: ${checkedColor} !important;
    border-color: ${checkedColor} !important;
}
`;
}
